// src/pages/Logout.jsx
// Simple component that logs the current user out and redirects to the login page.

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../data/users";

export default function Logout() {
  const navigate = useNavigate();
  useEffect(() => {
    logoutUser();
    navigate("/login");
  }, [navigate]);
  return null;
}